import * as z from "zod";

import { partnerInstallSchema } from "./shared";

export const listPartnerInstalls = {
  name: "listPartnerInstalls" as const,
  input: z.object({
    partnerId: z.string(),
    offset: z.number().int().min(0).default(0),
    limit: z.number().int().min(1).max(100).default(25),
  }),
  output: z.object({
    installs: z.array(partnerInstallSchema),
    total: z.number().int().min(0),
  }),
};
